import * as Sentry from "@sentry/react";

/**
 * Frontend error monitoring.
 *
 * The DSN resolves from REACT_APP_SENTRY_DSN when set, otherwise a
 * built-in production default (a Sentry DSN is public by design, it
 * ships in the client bundle and only permits sending events, never
 * reading them). In development with no env override there is no DSN,
 * so local runs stay silent. No session replay and no PII: Klareet is
 * used by students, some of them minors, and carries consent data, so
 * only the error and a scrubbed context are sent.
 */
const DEFAULT_PROD_DSN =
  "https://9ab8a2bacc418b1c266c895132e8e01b@o4511236374265856.ingest.us.sentry.io/4512016522412032";

const dsn =
  process.env.REACT_APP_SENTRY_DSN ||
  (process.env.NODE_ENV === "production" ? DEFAULT_PROD_DSN : undefined);

if (dsn) {
  Sentry.init({
    dsn,
    environment:
      process.env.REACT_APP_SENTRY_ENVIRONMENT ||
      process.env.NODE_ENV ||
      "production",
    release: process.env.REACT_APP_VERSION || undefined,
    sendDefaultPii: false,
  });
}

export { Sentry };
